<template>
  <div class="card p-shadow-app">
    <Toast :style="{ width: $isMobile() ? '85vw' : '' }" />
    <h1>Férias {{ showingNotApproved ? "Por Aprovar" : "Aprovadas" }}</h1>
    <Divider />
    <div class="p-field p-grid">
      <div class="p-col-12 p-md-2 p-mt-1">
        <label for="year-selector">Ano</label>
        <InputNumber
          id="year-selector"
          name="year-selector"
          :value="selectedYear"
          class="p-col-10"
          inputStyle="width: 75px"
          showButtons
          buttonLayout="horizontal"
          incrementButtonIcon="pi pi-plus"
          decrementButtonIcon="pi pi-minus"
          :step="1"
          :min="2025"
          :max="currentYear + 1"
          :useGrouping="false"
          @input="yearChanged"
        />
      </div>
      <div class="p-col-12 p-md-3 p-mt-1">
        <Button
          label="Ver Férias Aprovadas"
          v-if="showingNotApproved"
          @click="toogleVacationStatus"
        />

        <Button
          label="Ver Férias Por Aprovar"
          v-if="!showingNotApproved"
          @click="toogleVacationStatus"
        />
        <Button
          v-if="!showingNotApproved"
          icon="pi pi-file"
          label="Exportar CSV"
          class="p-button-primary p-ml-2"
          @click="exportCSV"
        />
      </div>
    </div>
    <Divider />
    <div style="height: 65vh">
      <DataTable
        :value="vacationsList"
        :filters.sync="filters"
        filterDisplay="row"
        :loading="loading"
        class="p-datatable-sm"
        responsiveLayout="scroll"
        :scrollable="true"
        scrollHeight="flex"
      >
        <template #empty> Não existem férias por aprovar. </template>
        <template #loading> A carregar. Por favor Aguarde... </template>
        <Column
          field="user_name"
          header="Funcionário"
          sortable
          filterField="user_name"
        >
          <template #filter="{ filterModel, filterCallback }">
            <InputText
              type="text"
              class="p-column-filter"
              v-model="filterModel.value"
              @input="filterCallback()"
            />
          </template>
          <template #body="slotProps">
            {{ slotProps.data.user_name }}
          </template>
        </Column>
        <Column
          field="dateStart"
          header="Data de Início"
          filterField="dateStart"
          dataType="date"
          sortable
        >
          <template #filter="{ filterModel, filterCallback }">
            <v-date-picker
              v-model="filterModel.value"
              @input="filterCallback()"
              :masks="{
                input: 'YYYY-MM-DD',
              }"
            >
              <template v-slot="{ inputValue, inputEvents }">
                <input
                  class="p-column-filter p-inputtext p-component"
                  :value="inputValue"
                  v-on="inputEvents"
                />
              </template>
            </v-date-picker>
          </template>
          <template #body="slotProps">
            {{ slotProps.data.start }}
          </template>
        </Column>
        <Column
          field="dateEnd"
          header="Data de Fim"
          filterField="dateEnd"
          dataType="date"
          sortable
        >
          <template #filter="{ filterModel, filterCallback }">
            <v-date-picker
              v-model="filterModel.value"
              @input="filterCallback()"
              :masks="{
                input: 'YYYY-MM-DD',
              }"
            >
              <template v-slot="{ inputValue, inputEvents }">
                <input
                  class="p-column-filter p-inputtext p-component"
                  :value="inputValue"
                  v-on="inputEvents"
                />
              </template>
            </v-date-picker>
          </template>
          <template #body="slotProps">
            {{ slotProps.data.end }}
          </template>
        </Column>
        <Column
          field="number_days"
          header="Dias"
          filterField="number_days"
          dataType="numeric"
        >
          <template #filter="{ filterModel, filterCallback }">
            <InputText
              type="text"
              class="p-column-filter"
              v-model="filterModel.value"
              @input="filterCallback()"
            />
          </template>
          <template #body="slotProps">
            {{ slotProps.data.number_days }}
          </template>
        </Column>
        <Column
          field="approved"
          header="Aprovado"
          filterField="approved"
          dataType="boolean"
        >
          <template #body="slotProps">
            {{ slotProps.data.approved == true ? "Sim" : "Não" }}
          </template>
          <template #filter="{ filterModel, filterCallback }">
            <Dropdown
              v-model="filterModel.value"
              @input="filterCallback()"
              :options="[
                { value: false, label: 'Não' },
                { value: true, label: 'Sim' },
              ]"
              optionLabel="label"
              optionValue="value"
              class="p-column-filter"
              :showClear="true"
            >
            </Dropdown>
          </template>
        </Column>
        <Column
          field="observations"
          header="Observações"
          filterField="observations"
        >
          <template #filter="{ filterModel, filterCallback }">
            <InputText
              type="text"
              class="p-column-filter"
              v-model="filterModel.value"
              @input="filterCallback()"
            />
          </template>
          <template #body="slotProps">
            {{ slotProps.data.observations }}
          </template>
        </Column>
        <Column
          field="createDate"
          header="Data de Criação"
          filterField="createDate"
          dataType="date"
          sortable
        >
          <template #filter="{ filterModel, filterCallback }">
            <v-date-picker
              v-model="filterModel.value"
              @input="filterCallback()"
              :masks="{
                input: 'YYYY-MM-DD',
              }"
            >
              <template v-slot="{ inputValue, inputEvents }">
                <input
                  class="p-column-filter p-inputtext p-component"
                  :value="inputValue"
                  v-on="inputEvents"
                />
              </template>
            </v-date-picker>
          </template>
          <template #body="slotProps">
            {{ slotProps.data.created_at }}
          </template>
        </Column>
        <Column v-if="showingNotApproved">
          <template #body="slotProps">
            <Button
              icon="pi pi-check"
              v-tooltip="'Aprovar Férias'"
              class="p-button-success p-mr-1"
              @click="confirmAproveVacation(slotProps.data)"
            />
            <Button
              icon="pi pi-times"
              v-tooltip="'Rejeitar Férias'"
              class="p-button-danger"
              @click="confirmRejectVacation(slotProps.data)"
            />
          </template>
        </Column>
        <Column v-if="!showingNotApproved">
          <template #body="slotProps">
            <Button
              icon="pi pi-undo"
              v-tooltip="'Reverter Aprovação'"
              class="p-button-warning"
              @click="confirmUnapproveVacation(slotProps.data)"
            />
          </template>
        </Column>
      </DataTable>
    </div>
    <Dialog
      :visible.sync="aproveVacationDialog"
      :position="$isMobile() ? '' : 'top'"
      :style="{ width: $isMobile() ? '100vw' : '30vw' }"
      header="Aprovar Férias"
      :modal="true"
    >
      <div class="confirmation-content">
        <i class="pi pi-exclamation-triangle p-mr-3" style="font-size: 2rem" />
        <span v-if="vacation">
          <span>
            Tem a certeza que pretende aprovar as férias do funcionário
            <u>{{ vacation.user_name }}</u> com
            <u>início no dia {{ vacation.start }}</u> e
            <u>fim no dia {{ vacation.end }}</u>
            (<u>{{ vacation.number_days }} dias de férias</u>)?
          </span>
        </span>
      </div>
      <template #footer>
        <Button
          label="Aprovar"
          icon="pi pi-check"
          class="p-button-success"
          @click="approveVacation"
        />
        <Button
          label="Cancelar"
          icon="pi pi-times"
          class="p-button-danger"
          @click="aproveVacationDialog = false"
        />
      </template>
    </Dialog>
    <Dialog
      :visible.sync="rejectVacationDialog"
      :position="$isMobile() ? '' : 'top'"
      :style="{ width: $isMobile() ? '100vw' : '30vw' }"
      header="Rejeitar Férias"
      :modal="true"
    >
      <div class="confirmation-content">
        <i class="pi pi-exclamation-triangle p-mr-3" style="font-size: 2rem" />
        <span v-if="vacation">
          <span>
            Tem a certeza que pretende rejeitar as férias do funcionário
            <u>{{ vacation.user_name }}</u> com
            <u>início no dia {{ vacation.start }}</u> e
            <u>fim no dia {{ vacation.end }}</u>
            (<u>{{ vacation.number_days }} dias de férias</u>)?
            <br /><br />
            <strong>Esta ação irá eliminar o registo e notificar o funcionário por email.</strong>
          </span>
        </span>
      </div>
      <template #footer>
        <Button
          label="Rejeitar"
          icon="pi pi-times"
          class="p-button-danger"
          @click="rejectVacation"
        />
        <Button
          label="Cancelar"
          icon="pi pi-arrow-left"
          class="p-button-secondary"
          @click="rejectVacationDialog = false"
        />
      </template>
    </Dialog>
    <Dialog
      :visible.sync="unapproveVacationDialog"
      :position="$isMobile() ? '' : 'top'"
      :style="{ width: $isMobile() ? '100vw' : '30vw' }"
      header="Reverter Aprovação"
      :modal="true"
    >
      <div class="confirmation-content">
        <i class="pi pi-exclamation-triangle p-mr-3" style="font-size: 2rem" />
        <span v-if="vacation">
          <span>
            Tem a certeza que pretende reverter a aprovação das férias do
            funcionário <u>{{ vacation.user_name }}</u> com
            <u>início no dia {{ vacation.start }}</u> e
            <u>fim no dia {{ vacation.end }}</u>
            (<u>{{ vacation.number_days }} dias de férias</u>)?
            <br /><br />
            <strong
              >As férias voltarão ao estado "por aprovar" e o funcionário
              poderá alterá-las ou eliminá-las.</strong
            >
          </span>
        </span>
      </div>
      <template #footer>
        <Button
          label="Reverter"
          icon="pi pi-undo"
          class="p-button-warning"
          @click="unapproveVacation"
        />
        <Button
          label="Cancelar"
          icon="pi pi-arrow-left"
          class="p-button-secondary"
          @click="unapproveVacationDialog = false"
        />
      </template>
    </Dialog>
  </div>
</template>

<script>
import vacationsService from "../services/vacations.service";
import { FilterMatchMode } from "primevue/api/";

export default {
  name: "vacationApprove",
  data() {
    return {
      filters: {
        user_name: { value: null, matchMode: FilterMatchMode.CONTAINS },
        dateStart: { value: null, matchMode: FilterMatchMode.DATE_IS },
        dateEnd: { value: null, matchMode: FilterMatchMode.DATE_IS },
        createDate: { value: null, matchMode: FilterMatchMode.DATE_IS },
        number_days: { value: null, matchMode: FilterMatchMode.EQUALS },
        approved: { value: null, matchMode: FilterMatchMode.EQUALS },
        observations: { value: null, matchMode: FilterMatchMode.CONTAINS },
      },
      loading: true,
      vacationsList: [],
      selectedYear: new Date().getFullYear(),
      currentYear: new Date().getFullYear(),
      vacation: {},
      aproveVacationDialog: false,
      rejectVacationDialog: false,
      unapproveVacationDialog: false,
      showingNotApproved: true,
      requestId: 0,
    };
  },
  created() {
    this.getVacationsNotApproved();
  },
  methods: {
    yearChanged(year) {
      this.selectedYear = year;
      if (this.showingNotApproved) {
        this.getVacationsNotApproved();
      } else {
        this.getVacationsApproved();
      }
    },
    getVacationsNotApproved() {
      this.loading = true;
      const currentRequest = ++this.requestId;
      return vacationsService
        .getVacationsToApprove(this.selectedYear)
        .then((response) => {
          if (currentRequest !== this.requestId) return;
          response = response.map((v) => ({
            ...v,
            dateStart: new Date(v.start),
            dateEnd: new Date(v.end),
            createDate: new Date(v.created_at),
          }));
          this.vacationsList = response;
          this.showingNotApproved = true;
          this.loading = false;
        });
    },
    getVacationsApproved() {
      this.loading = true;
      const currentRequest = ++this.requestId;
      return vacationsService
        .getVacationsApproved(this.selectedYear)
        .then((response) => {
          if (currentRequest !== this.requestId) return;
          this.vacationsList = response;
          this.showingNotApproved = false;
          this.loading = false;
        });
    },
    confirmAproveVacation(vacations) {
      this.vacation = vacations;
      this.aproveVacationDialog = true;
    },
    approveVacation() {
      let vacationId = this.vacation.id;
      const areYou = (vacationAux) => {
        return vacationAux.id == vacationId;
      };
      let params = {
        status: 1,
        id: this.vacation.id,
      };
      this.aproveVacationDialog = false;
      this.vacation = {};

      return vacationsService.changeVacationStatus(params).then((response) => {
        this.loading = false;
        if (!response) {
          return this.$toast.add({
            severity: "error",
            summary: "Erro",
            detail: "Ocorreu um erro ao aprovar as férias",
            life: 3000,
          });
        }
        let vacationIndex = this.vacationsList.findIndex(areYou);
        if (vacationIndex >= 0) {
          this.vacationsList.splice(vacationIndex, 1);
        }
        return this.$toast.add({
          severity: "success",
          summary: "Férias aprovadas",
          detail: "As férias foram aprovadas com sucesso",
          life: 3000,
        });
      });
    },
    confirmRejectVacation(vacations) {
      this.vacation = vacations;
      this.rejectVacationDialog = true;
    },
    rejectVacation() {
      let vacationId = this.vacation.id;
      const areYou = (vacationAux) => {
        return vacationAux.id == vacationId;
      };
      let params = {
        id: this.vacation.id,
      };
      this.rejectVacationDialog = false;
      this.vacation = {};

      return vacationsService.rejectVacation(params).then((response) => {
        this.loading = false;
        if (!response || response.error) {
          return this.$toast.add({
            severity: "error",
            summary: "Erro",
            detail: response?.message || "Ocorreu um erro ao rejeitar as férias",
            life: 3000,
          });
        }
        let vacationIndex = this.vacationsList.findIndex(areYou);
        if (vacationIndex >= 0) {
          this.vacationsList.splice(vacationIndex, 1);
        }
        return this.$toast.add({
          severity: "success",
          summary: "Férias rejeitadas",
          detail: "As férias foram rejeitadas com sucesso",
          life: 3000,
        });
      });
    },
    confirmUnapproveVacation(vacations) {
      this.vacation = vacations;
      this.unapproveVacationDialog = true;
    },
    unapproveVacation() {
      let vacationId = this.vacation.id;
      const areYou = (vacationAux) => {
        return vacationAux.id == vacationId;
      };
      let params = {
        id: this.vacation.id,
      };
      this.unapproveVacationDialog = false;
      this.vacation = {};

      return vacationsService.unapproveVacation(params).then((response) => {
        this.loading = false;
        if (!response) {
          return this.$toast.add({
            severity: "error",
            summary: "Erro",
            detail: "Ocorreu um erro ao reverter a aprovação",
            life: 3000,
          });
        }
        let vacationIndex = this.vacationsList.findIndex(areYou);
        if (vacationIndex >= 0) {
          this.vacationsList.splice(vacationIndex, 1);
        }
        return this.$toast.add({
          severity: "success",
          summary: "Aprovação revertida",
          detail: "As férias voltaram ao estado por aprovar",
          life: 3000,
        });
      });
    },
    toogleVacationStatus() {
      if (this.showingNotApproved) {
        return this.getVacationsApproved();
      }
      return this.getVacationsNotApproved();
    },
    async exportCSV() {
      this.loading = true;
      try {
        const response = await vacationsService.exportApprovedVacationsCSV(
          this.selectedYear
        );
        if (!response) {
          return this.$toast.add({
            severity: "error",
            summary: "Erro",
            detail: "Não foi possível exportar os dados.",
            life: 3000,
          });
        }
        const url = window.URL.createObjectURL(new Blob([response]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute(
          "download",
          `ferias_aprovadas_${this.selectedYear}.csv`
        );
        document.body.appendChild(link);
        link.click();
        link.remove();
      } catch (error) {
        this.$toast.add({
          severity: "error",
          summary: "Erro",
          detail: "Não foi possível exportar os dados.",
          life: 3000,
        });
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>
